import { type MarkdownToJSX, parser } from "markdown-to-jsx";

export const WORKFLOW_README_STUB =
  "Describe what this workflow does and how to use it.\n";

export function workflowReadmeDescription(raw: string): string | null {
  return raw.trim() === WORKFLOW_README_STUB.trim()
    ? null
    : extractReadmeDescription(raw);
}

export function extractReadmeDescription(raw: string): string | null {
  for (const para of raw.split(/\n\s*\n/)) {
    const head = para.trim();
    if (!head) continue;
    if (head.startsWith("#") || head.startsWith("**")) continue;
    return astToText(parser(head)).replace(/\s+/g, " ").trim();
  }
  return null;
}

function astToText(nodes: MarkdownToJSX.ASTNode[]): string {
  let out = "";
  for (const n of nodes) {
    if ("text" in n && typeof n.text === "string") out += n.text;
    else if ("alt" in n && typeof n.alt === "string") out += n.alt;
    else if ("children" in n && Array.isArray(n.children))
      out += astToText(n.children);
  }
  return out;
}
